import { UserActionTypes } from "./user.types";

export const setCurrentUser = (user) => ({
  type: UserActionTypes.SET_CURRENT_USER,
  payload: user,
});

export const sessionExpired = (reason = null) => ({
  type: UserActionTypes.SESSION_EXPIRED,
  payload: reason,
});

export const updateDistros = (distros) => ({
  type: UserActionTypes.UPDATE_DISTROS,
  payload: distros,
});

export const clearSessionExpired = () => ({
  type: UserActionTypes.CLEAR_SESSION_EXPIRED,
});

export const updateToken = (token) => ({
  type: UserActionTypes.UPDATE_TOKEN,
  payload: token,
});
